import {lighten, styled} from '@mui/material/styles'
import Typography from '@mui/material/Typography'

export const StyledText = styled(Typography)(({theme}) => ({
  fontSize: '11px',
  lineHeight: '16px',
  color: lighten(theme.palette.primary.main, 0.35),
  wordBreak: 'break-word'
}))
